import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function BusinessIcon({ className }: IconProps) {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1545)">
        <path
          d="M84.4129 0H31.4588C29.4925 0 27.8984 1.60129 27.8984 3.57658V76.4428C27.8984 78.4181 29.4925 80.0194 31.4588 80.0194H84.4129C86.3793 80.0194 87.9733 78.4181 87.9733 76.4428V3.57658C87.9733 1.60129 86.3793 0 84.4129 0Z"
          fill="#EAEDF8"
        />
        <path
          d="M62.7583 56.6915H53.14C52.4757 56.6915 51.9443 56.1577 51.9443 55.4904V50.6593C51.9443 49.9921 52.4757 49.4583 53.14 49.4583H62.7583C63.4226 49.4583 63.954 49.9921 63.954 50.6593V55.4904C63.954 56.1577 63.4226 56.6915 62.7583 56.6915Z"
          fill="#DDE0E7"
        />
        <path
          d="M79.2847 56.6915H69.6664C69.0021 56.6915 68.4707 56.1577 68.4707 55.4904V50.6593C68.4707 49.9921 69.0021 49.4583 69.6664 49.4583H79.2847C79.949 49.4583 80.4804 49.9921 80.4804 50.6593V55.4904C80.4804 56.1577 79.949 56.6915 79.2847 56.6915Z"
          fill="#00416B"
        />
        <path
          d="M46.232 56.6915H36.6136C35.9494 56.6915 35.418 56.1577 35.418 55.4904V50.6593C35.418 49.9921 35.9494 49.4583 36.6136 49.4583H46.232C46.8962 49.4583 47.4276 49.9921 47.4276 50.6593V55.4904C47.4276 56.1577 46.8962 56.6915 46.232 56.6915Z"
          fill="#00416B"
        />
        <path
          d="M62.7583 42.6522H53.14C52.4757 42.6522 51.9443 42.1184 51.9443 41.4511V36.62C51.9443 35.9528 52.4757 35.4189 53.14 35.4189H62.7583C63.4226 35.4189 63.954 35.9528 63.954 36.62V41.4511C63.954 42.1184 63.4226 42.6522 62.7583 42.6522Z"
          fill="#00416B"
        />
        <path
          d="M79.2847 42.6522H69.6664C69.0021 42.6522 68.4707 42.1184 68.4707 41.4511V36.62C68.4707 35.9528 69.0021 35.4189 69.6664 35.4189H79.2847C79.949 35.4189 80.4804 35.9528 80.4804 36.62V41.4511C80.4804 42.1184 79.949 42.6522 79.2847 42.6522Z"
          fill="#00C4B3"
        />
        <path
          d="M46.232 42.6522H36.6136C35.9494 42.6522 35.418 42.1184 35.418 41.4511V36.62C35.418 35.9528 35.9494 35.4189 36.6136 35.4189H46.232C46.8962 35.4189 47.4276 35.9528 47.4276 36.62V41.4511C47.4276 42.1184 46.8962 42.6522 46.232 42.6522Z"
          fill="#00C4B3"
        />
        <path
          d="M62.7583 28.3192H53.14C52.4757 28.3192 51.9443 27.7854 51.9443 27.1181V22.287C51.9443 21.6198 52.4757 21.0859 53.14 21.0859H62.7583C63.4226 21.0859 63.954 21.6198 63.954 22.287V27.1181C63.954 27.7854 63.4226 28.3192 62.7583 28.3192Z"
          fill="#00416B"
        />
        <path
          d="M79.2847 28.3192H69.6664C69.0021 28.3192 68.4707 27.7854 68.4707 27.1181V22.287C68.4707 21.6198 69.0021 21.0859 69.6664 21.0859H79.2847C79.949 21.0859 80.4804 21.6198 80.4804 22.287V27.1181C80.4804 27.7854 79.949 28.3192 79.2847 28.3192Z"
          fill="#DDE0E7"
        />
        <path
          d="M46.232 28.3192H36.6136C35.9494 28.3192 35.418 27.7854 35.418 27.1181V22.287C35.418 21.6198 35.9494 21.0859 36.6136 21.0859H46.232C46.8962 21.0859 47.4276 21.6198 47.4276 22.287V27.1181C47.4276 27.7854 46.8962 28.3192 46.232 28.3192Z"
          fill="#DDE0E7"
        />
        <path
          d="M62.7583 13.9859H53.14C52.4757 13.9859 51.9443 13.4521 51.9443 12.7848V7.95378C51.9443 7.2865 52.4757 6.75269 53.14 6.75269H62.7583C63.4226 6.75269 63.954 7.2865 63.954 7.95378V12.7848C63.954 13.4521 63.4226 13.9859 62.7583 13.9859Z"
          fill="#DDE0E7"
        />
        <path
          d="M79.2847 13.9859H69.6664C69.0021 13.9859 68.4707 13.4521 68.4707 12.7848V7.95378C68.4707 7.2865 69.0021 6.75269 69.6664 6.75269H79.2847C79.949 6.75269 80.4804 7.2865 80.4804 7.95378V12.7848C80.4804 13.4521 79.949 13.9859 79.2847 13.9859Z"
          fill="#00C4B3"
        />
        <path
          d="M46.232 13.9859H36.6136C35.9494 13.9859 35.418 13.4521 35.418 12.7848V7.95378C35.418 7.2865 35.9494 6.75269 36.6136 6.75269H46.232C46.8962 6.75269 47.4276 7.2865 47.4276 7.95378V12.7848C47.4276 13.4521 46.8962 13.9859 46.232 13.9859Z"
          fill="#00416B"
        />
        <path
          d="M56.5673 80.0194H30.6349C29.1205 80.0194 27.9248 78.7649 27.9248 77.2169V77.03H59.4634C59.4634 78.6849 58.1615 80.0194 56.5673 80.0194Z"
          fill="#DDE0E7"
        />
        <path
          d="M85.0771 80.0194H59.1447C57.6302 80.0194 56.4346 78.7649 56.4346 77.2169V77.03H87.9732C87.9732 78.6849 86.6713 80.0194 85.0771 80.0194Z"
          fill="#DDE0E7"
        />
        <path
          d="M61.2701 63.3643H54.6542C53.7508 63.3643 53.0068 64.1116 53.0068 65.0191V79.9927H62.944V65.0191C62.944 64.1116 62.2001 63.3643 61.2967 63.3643H61.2701Z"
          fill="#00416B"
        />
        <path
          d="M79.763 61.7627H69.1881C68.7919 61.7627 68.4707 62.0853 68.4707 62.4834V72.0387C68.4707 72.4367 68.7919 72.7594 69.1881 72.7594H79.763C80.1592 72.7594 80.4804 72.4367 80.4804 72.0387V62.4834C80.4804 62.0853 80.1592 61.7627 79.763 61.7627Z"
          fill="#DDE0E7"
        />
        <path
          d="M46.7102 61.7627H36.1354C35.7392 61.7627 35.418 62.0853 35.418 62.4834V72.0387C35.418 72.4367 35.7392 72.7594 36.1354 72.7594H46.7102C47.1064 72.7594 47.4276 72.4367 47.4276 72.0387V62.4834C47.4276 62.0853 47.1064 61.7627 46.7102 61.7627Z"
          fill="#DDE0E7"
        />
        <path
          d="M34.8333 88H7.67873C6.13767 88 4.8623 86.7455 4.8623 85.1707V55.9175H37.942V84.8505C37.942 86.5854 36.5604 87.9733 34.8333 87.9733"
          fill="#EAEDF8"
        />
        <path
          d="M34.913 88H7.7053C6.13767 88 4.8623 86.6922 4.8623 85.064V84.8772H37.942C37.942 86.6121 36.5869 88 34.913 88Z"
          fill="#DDE0E7"
        />
        <path
          d="M34.3285 68.2754H22.6377C22.2122 68.2754 21.8672 68.6219 21.8672 69.0494V79.619C21.8672 80.0465 22.2122 80.3931 22.6377 80.3931H34.3285C34.7541 80.3931 35.0991 80.0465 35.0991 79.619V69.0494C35.0991 68.6219 34.7541 68.2754 34.3285 68.2754Z"
          fill="#DDE0E7"
        />
        <path
          d="M5.04851 64.8323H3.48088C1.54127 64.8323 -0.0263672 63.2575 -0.0263672 61.3091H8.52919C8.52919 63.2575 6.96156 64.8323 5.02194 64.8323"
          fill="#00C4B3"
        />
        <path
          d="M13.6305 64.8323H12.0629C10.1233 64.8323 8.55566 63.2575 8.55566 61.3091H17.1112C17.1112 63.2575 15.5436 64.8323 13.604 64.8323"
          fill="#00416B"
        />
        <path
          d="M22.1862 64.8323H20.6186C18.679 64.8323 17.1113 63.2575 17.1113 61.3091H25.6669C25.6669 63.2575 24.0993 64.8323 22.1596 64.8323"
          fill="#00C4B3"
        />
        <path
          d="M30.7419 64.8323H29.1742C27.2346 64.8323 25.667 63.2575 25.667 61.3091H34.2225C34.2225 63.2575 32.6549 64.8323 30.7153 64.8323"
          fill="#00416B"
        />
        <path
          d="M39.3239 64.8323H37.7563C35.8167 64.8323 34.249 63.2575 34.249 61.3091H42.8046C42.8046 63.2575 41.2369 64.8323 39.2973 64.8323"
          fill="#00C4B3"
        />
        <path
          d="M37.942 55.9441H31.7246L34.2488 61.4157H42.8043L37.942 55.9441Z"
          fill="#00C4B3"
        />
        <path
          d="M11.0798 55.9441L8.55566 61.4157H17.1378L18.2272 55.9441H11.0798Z"
          fill="#00416B"
        />
        <path
          d="M24.5771 55.9441L25.6931 61.4157H34.2486L31.7245 55.9441H24.5771Z"
          fill="#00416B"
        />
        <path
          d="M4.86232 55.9441L0 61.4157H8.55556L11.0797 55.9441H4.86232Z"
          fill="#00C4B3"
        />
        <path
          d="M18.2271 55.9441L17.1377 61.4157H25.6933L24.5773 55.9441H18.2271Z"
          fill="#00C4B3"
        />
        <path
          d="M16.872 70.5708H9.91065C8.95413 70.5708 8.18359 71.3448 8.18359 72.3057V88.0267H18.5991V72.3057C18.5991 71.3448 17.8285 70.5708 16.872 70.5708Z"
          fill="#00416B"
        />
        <path
          d="M7.91786 52.8213H35.099C36.6667 52.8213 37.942 54.1291 37.942 55.7573V55.9441H4.8623C4.8623 54.2092 6.21738 52.8213 7.89129 52.8213"
          fill="#DDE0E7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1545">
          <rect width="88" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
